import { Button, Modal, ModalContent, tokens } from "@blurb/codex-react";
import { Box, createStyles } from "@mantine/core";
import { RpiAlert } from "@rpi/openapi-core";

const useStyles = createStyles(() => ({
  body: {
    fontSize: tokens.font.size.base,
    lineHeight: tokens.font.lineHeight.normal,
  },
  buttonGroup: {
    display: "flex",
    gap: tokens.spacing["2"],
    justifyContent: "flex-end",
  },
}));

interface ConfirmationModalV2Props {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  error?: string;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  loadingLabel?: string;
}

export const ConfirmationModalV2: React.FC<ConfirmationModalV2Props> = ({
  opened,
  onClose,
  onConfirm,
  isLoading,
  error,
  title,
  message,
  confirmLabel = "Yes",
  cancelLabel = "No",
  loadingLabel,
}) => {
  const { classes } = useStyles();

  return (
    <Modal
      open={opened}
      onOpenChange={(isOpen) => {
        if (!isOpen && !isLoading) onClose();
      }}
    >
      <ModalContent size="small" title={title}>
        <Box className={classes.body}>{message}</Box>

        {error && <RpiAlert>{error}</RpiAlert>}

        <Box className={classes.buttonGroup}>
          <Button variant="outlined" intent="neutral" size="small" onClick={onClose} disabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button variant="filled" intent="brand" size="small" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? loadingLabel || confirmLabel : confirmLabel}
          </Button>
        </Box>
      </ModalContent>
    </Modal>
  );
};
